"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./style.sass");
var Button = function (_a) {
    var id = _a.id, name = _a.name, className = _a.className, text = _a.text, style = _a.style, icon = _a.icon, onClick = _a.onClick, disabled = _a.disabled;
    return (react_1.default.createElement("button", { className: "button ".concat(className), disabled: disabled, id: id ? id : "", name: name ? name : "", onClick: onClick, style: style },
        icon,
        text && react_1.default.createElement("span", { className: "btn-text" }, text)));
};
exports.default = Button;
